import * as React from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import Form from './common/Form';
import Cat from './cat-meow.png';

export default function Here({title, setEmail, setPassword, handleAction}){
	let navigate = useNavigate();
	
	return(
		<>
			<section className="virtual-arte">
				<div className="virtual-arte-1" alt="Image by <a href=https://pixabay.com/users/squarefrog-9690118/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=4754631>squarefrog</a> from <a href=https://pixabay.com/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=4754631>Pixabay</a>" >
				<img src={Cat} alt="cat" />
				<h1>Meow</h1>
				</div>
				
				<Form  title="Login" setEmail={setEmail} setPassword={setPassword} handleAction={() => handleAction(1)} />
				
				<h5 style={{textAlign: "center"}}>Or</h5>
				
				<div className="form-user">
					<Button  variant="outlined"  sx={{width: "100%", p: "0.8rem"}} onClick={() => {navigate('./register')}} >Sign Up</Button>
				</div>
				
			</section>
		</>
	);
}